import { BoardDoc } from './BoardDoc';

/** Open documents by id with reference counting, so two panes on one board share a doc. */
const open = new Map<string, { doc: BoardDoc; refs: number }>();

export function acquireBoard(boardId: string, remote: boolean): BoardDoc {
  const key = `${remote ? 'r' : 'l'}:${boardId}`;
  let entry = open.get(key);
  if (!entry) {
    entry = { doc: new BoardDoc(boardId, { remote }), refs: 0 };
    open.set(key, entry);
  }
  entry.refs++;
  return entry.doc;
}

export function releaseBoard(doc: BoardDoc): void {
  for (const [key, entry] of open) {
    if (entry.doc !== doc) continue;
    entry.refs--;
    if (entry.refs <= 0) {
      open.delete(key);
      doc.destroy();
    }
    return;
  }
}
